import { Editor, Transforms } from 'slate';

import {
  BOLD_DEFINITIONS,
  ITALIC_DEFINITIONS,
  LINK_DEFINITIONS,
  MENTION_DEFINITIONS,
} from './definitions';

const MARKS = [BOLD_DEFINITIONS.type, ITALIC_DEFINITIONS.type];
const INLINE_MARKS = [LINK_DEFINITIONS.type, MENTION_DEFINITIONS.type];

const removeMarks = (editor) => {
  const { selection } = editor;
  if (selection !== null) {
    const blockElementPath = selection.anchor.path[0];
    Transforms.select(editor, [blockElementPath]);

    // Remove marks and inline marks
    MARKS.forEach((mark) => Editor.removeMark(editor, mark));
    INLINE_MARKS.forEach((inlineMark) =>
      Transforms.unwrapNodes(editor, {
        match: (n) => n.type === inlineMark,
      })
    );
    if (editor.selection.anchor.path.length > 2) {
      Transforms.select(editor, {
        anchor: {
          path: [blockElementPath, 0, 0],
          offset: selection.anchor.offset,
        },
        focus: {
          path: [blockElementPath, 0, 0],
          offset: selection.focus.offset,
        },
      });
    } else {
      Transforms.select(editor, {
        anchor: {
          path: [blockElementPath, 0],
          offset: selection.anchor.offset,
        },
        focus: {
          path: [blockElementPath, 0],
          offset: selection.focus.offset,
        },
      });
    }
  }
};

export { removeMarks };
